export function shouldClosePhotoConsentModalForChatChange(
  previousMessagesBaseUrl,
  nextMessagesBaseUrl
) {
  if (!previousMessagesBaseUrl) return false;
  return previousMessagesBaseUrl !== nextMessagesBaseUrl;
}
